export default __webpack_public_path__ + "logic-pro.d6d7d1c6.png";